import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "index" }
const _hoisted_2 = {
  class: "ion-page",
  id: "main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_split_pane, { "content-id": "main" }, {
          default: _withCtx(() => [
            _createVNode(_component_Menu),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_view, {
                main: "",
                animated: false,
                id: "menu-content"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}